<template>
  <div class="x-alert-container">
    <div class="x-alert-btn-login">
      <span class="x-alert-text">{{ text }}</span>
      <img
        @click="closeModal()"
        :src="image_src"
        :alt="image_alt"
        class="x-alert-image"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'XAlert',
    props: {
      text: {
        type: String,
        default: 'message',
      },
      image_src: {
        type: String,
        default: '/playground_assets/close_red.svg',
      },
      image_alt: {
        type: String,
        default: 'image',
      },
    },
    methods: {
      closeModal() {
        this.$root.$emit('onCloseError');
      },
    },
  };
</script>

<style scoped>
  .x-alert-container {
    width: 100%;
    display: flex;
    position: relative;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 16px;
  }
  .x-alert-btn-login {
    flex: 0 0 auto;
    width: 100%;
    border: 1px solid #ff2444ff;
    cursor: pointer;
    height: 64px;
    display: flex;
    position: relative;
    align-items: center;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    justify-content: space-between;
    background: #fff;
  }
  .x-alert-text {
    color: #ff2444;
    font-size: 14px;
    font-style: normal;
    text-align: left;
    font-family: Montserrat;
    padding-right: 16px;
    letter-spacing: 2.4px;
    line-height: 1.3;
  }
  .x-alert-image {
    width: 24px;
    object-fit: cover;
  }
</style>
